const LoadingStore = {
  active: 0,
  show() {
    this.active += 1
  },
  hide() {
    this.active -= 1
  },
}

const Loading = {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          loadingStore: LoadingStore,
        }
      },
    })
    Object.defineProperty(Vue.prototype, '$loading', {
      get() {
        return this.$root.loadingStore
      },
    })
  },
}

export default Loading
